import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';
import React, { useMemo } from 'react';

function AlertSnackbar({ message, open, onClose, severity = 'error' }) {
  const msg = useMemo(() => {
    let text = (message || '').trim();
    if (text && !text.endsWith('.')) text += '.';
    return text;
  }, [message]);

  return msg ? (
    <Snackbar
      open={open && msg}
      {...(severity !== 'error' && { autoHideDuration: 4500 })}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        variant="filled"
        elevation={6}
        severity={severity}
        sx={{ width: '100%' }}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {msg}
      </Alert>
    </Snackbar>
  ) : null;
}

export default AlertSnackbar;
